// extracted by mini-css-extract-plugin
module.exports = {"backgroundWhite":"Layout_backgroundWhite__DDnqj","background":"Layout_background__fE-lN Layout_backgroundWhite__DDnqj"};